// extracted by mini-css-extract-plugin
export var chevron = "_i5-2";
export var dropdownItems = "_i5-0";
export var item = "_i5-1";